import React, { useState, useEffect } from 'react'
import {
  Col, Upload, Row, Input, Checkbox, DatePicker, Select, AutoComplete, Icon,
} from 'antd'
import * as UI from 'konsys-ui'
import _ from 'lodash'
import moment from 'moment'
import { useQuery } from '@apollo/react-hooks'
import {
  TIRE_SERIAL_NUMBER_LIST, TIRE_PATCH_TYPE_LIST, INVENTORIES, TIRE_INVENTORIES,
  SUPPLIERS,
} from '../../../constants/graph/query'
import { GET_REPAIR_JOBS } from '../../../constants/graphql/query'
import {
  detailMode, TIRE_PATCH_TYPE, STATUSTEXTSELECTOR, STATUSCOLORSELECTOR,
} from '../constants'
import { checkFloat, checkInt } from '../../../utils/util-services'
import { UploadWithModal } from '../../../components/common'
import { theme } from '../../../styles/_variables'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Upload box
5: Select
6: TextArea
7: Upload
*/

const CreateMode = ({
  data, onChangeHandler, mutationVariables, setMutationVariables,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Input {...data.props} onChange={e => onChangeHandler(data.id, e.target.value)} />
          </UI.Div>
        </Col>
      )
    case 1:
      return <UI.Input {...data.props} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return <UI.Select dropdown buttonProps={{ style: { height: '34px', padding: '4px 24px' }, text: data.children[0].text }} data={data.children} {...data.props} />
    case 3.1: {
      const {
        loading: repairLoading, data: repairData, error: repairError, refetch: repairRefetch,
      } = useQuery(GET_REPAIR_JOBS)
      if (repairLoading && _.isEmpty(repairData)) return <UI.Loading />
      if (repairError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              showSearch
              style={{ width: '100%' }}
              loading={repairLoading}
              filterOption={(input, option) => option.props.refId.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
              }}
              onSearch={e => repairRefetch({ refId: e })}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                repairData.RepairJobList.lists.map(v => <Select.Option key={v.id} value={v.id} refId={v.refId}>{v.refId}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    }
    case 3.2: {
      // const [partList, setPartList] = useState([{
      //   id: 0, inventoryOptionId: undefined, quantity: '',
      // }])
      const {
        loading: inventoryLoading, data: inventoryData, error: inventoryError, refetch: inventoryRefetch,
      } = useQuery(INVENTORIES, { variables: { supplierId: mutationVariables.supplierId }, skip: !mutationVariables.supplierId })
      const {
        loading: tireInventoryLoading, data: tireInventoryData, error: tireInventoryError, refetch: tireInventoryRefetch,
      } = useQuery(TIRE_INVENTORIES, { variables: { supplierId: mutationVariables.supplierId }, skip: !mutationVariables.supplierId })
      // if (inventoryLoading && _.isEmpty(inventoryData)) return <UI.Loading />
      // if (tireInventoryLoading && _.isEmpty(tireInventoryData)) return <UI.Loading />
      // if (inventoryError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      // if (tireInventoryError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Row gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
              <Col span={3}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>รหัสสินค้า</p>
              </Col>
              <Col span={6}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>ชื่อสินค้า</p>
              </Col>
              <Col span={4}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>จำนวนในคลังสำนักงานใหญ่</p>
              </Col>
              <Col span={2}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>จำนวนที่ขอซื้อ</p>
              </Col>
              <Col span={3}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>จำนวนที่ซื้อแล้ว</p>
              </Col>
              <Col span={2}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>ราคาเก่า</p>
              </Col>
              <Col span={3}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>หมายเหตุ</p>
              </Col>
            </Row>
            {
              mutationVariables.Items.map((v, index) => (
                <Row key={v.id} gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
                  <Col span={3}>
                    <UI.P>{v.sku}</UI.P>
                  </Col>
                  <Col span={6}>
                    <Select
                      showSearch
                      style={{ width: '100%' }}
                      loading={inventoryLoading || tireInventoryLoading}
                      value={v.productName}
                      onSelect={(e) => {
                        if (!_.some(mutationVariables.Items, { productName: e })) {
                          let selected = _.find(inventoryData.inventoryList.data.list, o => o.productName === e)
                          if (selected === undefined) selected = _.find(tireInventoryData.TireList.lists, o => o.productName === e)
                          const newPartList = _.cloneDeep(mutationVariables.Items)
                          newPartList.splice(index, 1, {
                            id: v.id,
                            inventoryOptionId: selected.inventoryOptions[0].id,
                            sku: selected.sku,
                            productName: e,
                            totalAmount: _.find(selected.inventoryOptions[0].stockLocation, o => o.warehouse.warehouseCode === '00001').quantity,
                            preorderItemQuantity: _.find(selected.inventoryOptions[0].stockLocation, o => o.warehouse.warehouseCode === '00001').preorderItemQuantity,
                            oldBuyPrice: selected.inventoryOptions[0].buyPrice,
                            price: '',
                          })
                          // onChangeHandler(data.id, [...newPartList])
                          // setPartList([...newPartList])
                          const Items = _.map(newPartList, u => _.pick(u, ['inventoryOptionId', 'quantity', 'price']))
                          onChangeHandler(data.id, [...newPartList])
                        }
                      }}
                      onSearch={ (e) => {
                        inventoryRefetch({ productName: e })
                        tireInventoryRefetch({ productName: e })
                      }}
                      placeholder='พิมพ์เพื่อค้นหา'
                    >
                      {
                        !inventoryLoading && !_.isEmpty(inventoryData)
                        && inventoryData.inventoryList.data.list.map(u => (
                          <Select.Option key={u.id} value={u.productName} disabled={
                            mutationVariables.Items.some(item => item.inventoryOptionId === u.id) && u.id !== v.id
                          }>{u.productName}</Select.Option>
                        ))
                      }
                      {
                        !tireInventoryLoading && !_.isEmpty(tireInventoryData)
                        && tireInventoryData.TireList.lists.map(u => (
                          <Select.Option key={u.id} value={u.productName} disabled={
                            mutationVariables.Items.some(item => item.inventoryOptionId === u.id) && u.id !== v.id
                          }>{u.productName}</Select.Option>
                        ))
                      }
                    </Select>
                  </Col>
                  <Col span={4}>
                    <UI.P>{v.totalAmount}</UI.P>{v.preorderItemQuantity > 0 && <UI.P margin='0 0 0 8px'>(+{v.preorderItemQuantity})</UI.P>}
                  </Col>
                  <Col span={2}>
                    <Input
                      width='100%'
                      placeholder='จำนวน'
                      onChange={(e) => {
                        const newPartList = _.cloneDeep(mutationVariables.Items)
                        newPartList[index].quantity = parseInt(e.target.value, 10)
                        onChangeHandler(data.id, [...newPartList])
                        // setPartList([...newPartList])
                        const Items = _.map(newPartList, u => _.pick(u, ['inventoryOptionId', 'quantity', 'price']))
                        // onChangeHandler(data.id, [...Items])
                      }}
                      onKeyDown={(e) => {
                        if (!checkInt(e)) {
                          e.preventDefault()
                        }
                      }}
                    />
                  </Col>
                  <Col span={3}>
                    <UI.P>{v.orderedQuantity || 0}</UI.P>
                  </Col>
                  <Col span={2}>
                    <UI.P>{v.oldBuyPrice || 0}</UI.P>
                  </Col>
                  <Col span={3}>
                    <Input
                      width='100%'
                      placeholder='หมายเหตุ'
                      onChange={(e) => {
                        const newPartList = _.cloneDeep(mutationVariables.Items)
                        newPartList[index].remark = e.target.value
                        // setPartList([...newPartList])
                        // const Items = _.map(newPartList, u => _.pick(u, ['inventoryOptionId', 'quantity', 'price']))
                        // onChangeHandler(data.id, [...Items])
                        onChangeHandler(data.id, [...newPartList])
                      }}
                    />
                  </Col>
                  <Col span={1}>
                    <Icon
                      className="dynamic-delete-button"
                      type="minus-circle-o"
                      onClick={() => {
                        const oldPartList = _.cloneDeep(mutationVariables.Items)
                        _.remove(oldPartList, n => n.id === v.id)
                        // setPartList(oldPartList)
                        const Items = _.map(oldPartList, u => _.pick(u, ['inventoryOptionId', 'quantity', 'price']))
                        // onChangeHandler(data.id, [...Items])
                        onChangeHandler(data.id, [...oldPartList])
                      }}
                    />
                  </Col>
                </Row>
              ))
            }
            <UI.Button
              type="dashed"
              icon='fas fa-plus'
              text='เพิ่มสินค้า'
              disabled={mutationVariables.Items.length >= 30}
              onClick={() => {
                // setPartList([...partList, {
                //   id: partList.length, inventoryOptionId: undefined, quantity: '', price: '',
                // }])
                // onChangeHandler(data.id, [...partList, {
                //   inventoryOptionId: undefined, quantity: '', price: '',
                // }])
                onChangeHandler(data.id, [...mutationVariables.Items, {
                  id: mutationVariables.Items.length, inventoryOptionId: undefined, quantity: '', price: '',
                }])
              }}>
          </UI.Button>
          </UI.Div>
        </Col>
      )
    }
    case 3.3: {
      const {
        loading: supplierLoading, data: supplierData, error: supplierError, refetch: supplierRefetch,
      } = useQuery(SUPPLIERS)
      if (supplierLoading && _.isEmpty(supplierData)) return <UI.Loading />
      if (supplierError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              showSearch
              style={{ width: '100%' }}
              loading={supplierLoading}
              filterOption={(input, option) => (option.props.name || option.props.children || '').toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
                setMutationVariables({
                  ...mutationVariables,
                  supplierId: e,
                  Items: [{
                    id: 0, inventoryOptionId: undefined, quantity: '', price: '',
                  }],
                })
              }}
              onSearch={e => supplierRefetch({ refId: e })}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                supplierData.supplierList.data.list.map(v => <Select.Option key={v.id} value={v.id} name={v.name}>{v.name}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    }
    case 5:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => v.originFileObj))}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 7:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Input.TextArea rows={4} style={{ margin: '0 0 16px' }} onChange={e => onChangeHandler(data.id, e.target.value)} />
        </Col>
      )
    case 8:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='0 0 16px'>{data.label}</UI.P>
            <DatePicker onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))} style={{ marginBottom: 16 }} />
          </UI.Div>
        </Col>
      )
    case 11:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
          </UI.Div>
        </Col>
      )
    case 12:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            {/* <Select
              style={{ width: '100%' }}
              disabled={true}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
              }}
              defaultValue={false}
            >
                <Select.Option key={1} value={false}>รออนุมัติ</Select.Option>
                <Select.Option key={2} value={true}>รถยังไม่เข้าอู่</Select.Option>
            </Select> */}
            <UI.P margin='0 8px 16px 0'>รออนุมัติ</UI.P>
          </UI.Div>
        </Col>
      )
    case 13:
      return (
        <Col span={data.span} offset={data.offset}>
        </Col>
      )
    case 14:
      return null
    case 15:
      return null
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, disabled, initialData, onChangeHandler, tireInfoData, setTireInfoId, mutationVariables, setMutationVariables,
}) => {
  console.info(mutationVariables)
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Input {...data.props} value={mutationVariables[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)} disabled={disabled} />
          </UI.Div>
        </Col>
      )
    case 1:
      return <UI.Input disabled={disabled} {...data.props} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return <UI.Select dropdown buttonProps={{ style: { height: '34px', padding: '4px 24px' }, text: data.children[0].text }} data={data.children} {...data.props} />
    case 3.1: {
      const {
        loading: repairLoading, data: repairData, error: repairError, refetch: repairRefetch,
      } = useQuery(GET_REPAIR_JOBS)
      if (repairLoading && _.isEmpty(repairData)) return <UI.Loading />
      if (repairError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              showSearch
              defaultValue={initialData.RepairJob ? initialData.RepairJob.refId : ''}
              disabled={disabled}
              style={{ width: '100%' }}
              loading={repairLoading}
              filterOption={(input, option) => option.props.refId.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
              }}
              onSearch={e => repairRefetch({ refId: e })}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                repairData.RepairJobList.lists.map(v => <Select.Option key={v.id} value={v.id} refId={v.refId}>{v.refId}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    }
    case 3.2: {
      const {
        loading: inventoryLoading, data: inventoryData, error: inventoryError, refetch: inventoryRefetch,
      } = useQuery(INVENTORIES, { variables: { limit: 5, supplierId: mutationVariables.supplierId }, skip: !mutationVariables.supplierId })
      const {
        loading: tireInventoryLoading, data: tireInventoryData, error: tireInventoryError, refetch: tireInventoryRefetch,
      } = useQuery(TIRE_INVENTORIES, { variables: { limit: 5, supplierId: mutationVariables.supplierId }, skip: !mutationVariables.supplierId })
      // if (inventoryLoading && _.isEmpty(inventoryData)) return <UI.Loading />
      // if (tireInventoryLoading && _.isEmpty(tireInventoryData)) return <UI.Loading />
      // if (inventoryError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      // if (tireInventoryError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Row gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
              <Col span={3}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>รหัสสินค้า</p>
              </Col>
              <Col span={6}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>ชื่อสินค้า</p>
              </Col>
              <Col span={4}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>จำนวนในคลังสำนักงานใหญ่</p>
              </Col>
              <Col span={2}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>จำนวนที่ขอซื้อ</p>
              </Col>
              <Col span={3}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>จำนวนที่ซื้อแล้ว</p>
              </Col>
              <Col span={2}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>ราคาเก่า</p>
              </Col>
              <Col span={3}>
                <p className='text-sm font-extralight' style={{ color: theme.color.dark }}>หมายเหตุ</p>
              </Col>
            </Row>
            {
              mutationVariables.Items.map((v, index) => (
                <Row key={v.id} gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
                  <Col span={3}>
                    <UI.P>{v.sku}</UI.P>
                  </Col>
                  <Col span={6}>
                    <Select
                      showSearch
                      style={{ width: '100%' }}
                      disabled={disabled}
                      loading={inventoryLoading || tireInventoryLoading}
                      defaultValue={v.productName}
                      value={v.productName}
                      onSelect={(e) => {
                        if (!_.some(mutationVariables.Items, { productName: e })) {
                          let selected = _.find(inventoryData.inventoryList.data.list, o => o.productName === e)
                          if (selected === undefined) selected = _.find(tireInventoryData.TireList.lists, o => o.productName === e)
                          const newPartList = _.cloneDeep(mutationVariables.Items)
                          newPartList.splice(index, 1, {
                            id: v.id,
                            inventoryOptionId: selected.inventoryOptions[0].id,
                            sku: selected.sku,
                            productName: e,
                            totalAmount: _.find(selected.inventoryOptions[0].stockLocation, o => o.warehouse.warehouseCode === '00001').quantity,
                            preorderItemQuantity: _.find(selected.inventoryOptions[0].stockLocation, o => o.warehouse.warehouseCode === '00001').preorderItemQuantity,
                            oldBuyPrice: selected.inventoryOptions[0].buyPrice || 0,
                            price: selected.inventoryOptions[0].buyPrice || 0,
                          })
                          // setPartList([...newPartList])
                          // const Items = _.map(newPartList, u => _.pick(u, ['inventoryOptionId', 'quantity', 'price']))
                          // onChangeHandler(data.id, [...Items])
                          onChangeHandler(data.id, [...newPartList])
                        }
                      }}
                      onSearch={ (e) => {
                        inventoryRefetch({ productName: e })
                        tireInventoryRefetch({ productName: e })
                      }}
                      placeholder='พิมพ์เพื่อค้นหา'
                    >
                      {
                        !inventoryLoading && !_.isEmpty(inventoryData)
                        && inventoryData.inventoryList.data.list.map(u => <Select.Option key={u.id} value={u.productName} disabled={
                          mutationVariables.Items.some(item => item.inventoryOptionId === u.id) && u.id !== v.id
                        }>{u.productName}</Select.Option>)
                      }
                      {
                        !tireInventoryLoading && !_.isEmpty(tireInventoryData)
                        && tireInventoryData.TireList.lists.map(u => <Select.Option key={u.id} value={u.productName} disabled={
                          mutationVariables.Items.some(item => item.inventoryOptionId === u.id) && u.id !== v.id
                        }>{u.productName}</Select.Option>)
                      }
                    </Select>
                  </Col>
                  <Col span={4}>
                    <UI.P>{v.totalAmount}</UI.P>{v.preorderItemQuantity && <UI.P margin='0 0 0 8px'>(+{v.preorderItemQuantity})</UI.P>}
                  </Col>
                  <Col span={2}>
                    <Input
                      width='100%'
                      defaultValue={v.quantity}
                      disabled={disabled}
                      placeholder='จำนวน'
                      onChange={(e) => {
                        const newPartList = _.cloneDeep(mutationVariables.Items)
                        newPartList[index].quantity = parseInt(e.target.value, 10)
                        // setPartList([...newPartList])
                        // const Items = _.map(newPartList, u => _.pick(u, ['inventoryOptionId', 'quantity', 'price']))
                        // onChangeHandler(data.id, [...Items])
                        onChangeHandler(data.id, [...newPartList])
                      }}
                      onKeyDown={(e) => {
                        if (!checkInt(e)) {
                          e.preventDefault()
                        }
                      }}
                    />
                  </Col>
                  <Col span={3}>
                    <UI.P>{v.orderedQuantity || 0}</UI.P>
                  </Col>
                  <Col span={2}>
                    <UI.P>{v.oldBuyPrice}</UI.P>
                  </Col>
                  <Col span={3}>
                    <Input
                      width='100%'
                      disabled={disabled}
                      placeholder='หมายเหตุ'
                      value={v.remark}
                      onChange={(e) => {
                        const newPartList = _.cloneDeep(mutationVariables.Items)
                        newPartList[index].remark = e.target.value
                        // setPartList([...newPartList])
                        // const Items = _.map(newPartList, u => _.pick(u, ['inventoryOptionId', 'quantity', 'price']))
                        // onChangeHandler(data.id, [...Items])
                        onChangeHandler(data.id, [...newPartList])
                      }}
                    />
                  </Col>
                  <Col span={1}><Icon
                    className="dynamic-delete-button"
                    type="minus-circle-o"
                    onClick={() => {
                      if (!disabled) {
                        const oldPartList = _.cloneDeep(mutationVariables.Items)
                        _.remove(oldPartList, n => n.id === v.id)
                        // setPartList(oldPartList)
                        // const Items = _.map(oldPartList, u => _.pick(u, ['inventoryOptionId', 'quantity', 'price']))
                        // onChangeHandler(data.id, [...Items])
                        onChangeHandler(data.id, oldPartList)
                      }
                    }}
                  /></Col>
                </Row>
              ))
            }
            <UI.Button
              type="dashed"
              icon='fas fa-plus'
              text='เพิ่มสินค้า'
              disabled={disabled || mutationVariables.Items.length >= 30}
              onClick={() => {
                // setPartList([...partList, {
                //   id: partList.length, inventoryOptionId: undefined, quantity: '',
                // }])
                onChangeHandler(data.id, [...mutationVariables.Items, {
                  id: mutationVariables.Items.length, inventoryOptionId: undefined, quantity: '',
                }])
              }}>
            </UI.Button>
          </UI.Div>
        </Col>
      )
    }
    case 3.3: {
      const {
        loading: supplierLoading, data: supplierData, error: supplierError, refetch: supplierRefetch,
      } = useQuery(SUPPLIERS)
      if (supplierLoading && _.isEmpty(supplierData)) return <UI.Loading />
      if (supplierError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              showSearch
              style={{ width: '100%' }}
              loading={supplierLoading}
              disabled={disabled}
              filterOption={(input, option) => (option.props.name || option.props.children || '').toLowerCase().indexOf(input.toLowerCase()) >= 0}
              value={mutationVariables.supplierId}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
                setMutationVariables({
                  ...mutationVariables,
                  supplierId: e,
                  Items: [{
                    id: 0, inventoryOptionId: undefined, quantity: '', price: '',
                  }],
                })
              }}
              onSearch={e => supplierRefetch({ refId: e })}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                supplierData.supplierList.data.list.map(v => <Select.Option key={v.id} value={v.id} name={v.name}>{v.name}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    }
    case 4:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            disabled={disabled}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            defaultFileList={initialData[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
            listType='picture'
            button={data.props}
          />
        </Col>
      )
    case 5: {
      const [file, setFile] = useState(!_.isUndefined(initialData[data.id]) && !_.isNull(initialData[data.id]) && initialData[data.id].map(v => (
        {
          name: v.filename,
          url: v.url,
          uid: v.url,
        })))
      const [initialFile, setInitialFile] = useState(initialData[data.id])
      if (!(initialData[data.id] === initialFile)) {
        setFile(file.concat(initialData[data.id].filter(e => !initialFile.includes(e)).map(v => (
          {
            name: v.filename,
            url: v.url,
            uid: v.url,
          }
        ))))
        setInitialFile(initialData[data.id])
      }
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            onChange={(e) => {
              onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? v : v.originFileObj)))
              setFile(e.fileList.map(v => (_.isUndefined(v.originFileObj) ? v : v.originFileObj)))
            }}
            customRequest={() => null}
            processData={false}
            disabled={disabled}
            fileList={file}
            beforeUpload={() => false}
            multiple={true}
            defaultFileList={!_.isUndefined(initialData[data.id]) && !_.isNull(initialData[data.id]) && initialData[data.id].map(v => (
              {
                name: v.filename,
                url: v.url,
                uid: v.url,
              }))}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    }
    case 7:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Input.TextArea rows={4} disabled={disabled} style={{ margin: '0 0 16px' }} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)} />
        </Col>
      )
    case 8:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='0 0 16px'>{data.label}</UI.P>
            <DatePicker onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))} disabled={disabled} defaultValue={moment(initialData[data.id])} style={{ marginBottom: 16 }} />
          </UI.Div>
        </Col>
      )
    case 11:
      return (
        <Col span={data.span} offset={data.offset}>
          {initialData.status === 'CANCEL'
            && <UI.Div display='flex' flexDirection='column'>
              <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
              <UI.P margin='0 8px 16px 0'>{initialData[data.id]}</UI.P>
            </UI.Div>
          }
        </Col>
      )
    case 12:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <UI.P color={STATUSCOLORSELECTOR(initialData[data.id])} margin='0 8px 16px 0'>{STATUSTEXTSELECTOR(initialData[data.id])}</UI.P>
          </UI.Div>
        </Col>
      )
    case 13:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0' bold>{data.label}</UI.P>
            {!_.isEmpty(tireInfoData)
              && <UI.Div>
                <UI.Div display='flex' flexDirection='row'>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ชื่อ</UI.P>
                      <UI.P margin='0 8px 16px 0' >{tireInfoData.TireSerialNumberInfo.inventoryOption.inventory.productName}</UI.P>
                    </UI.Div>
                  </Col>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ยี่ห้อ</UI.P>
                      <UI.P margin='0 8px 16px 0' >{tireInfoData.TireSerialNumberInfo.inventoryOption.inventory.brand}</UI.P>
                    </UI.Div>
                  </Col>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ประเภทยาง</UI.P>
                      <UI.P margin='0 8px 16px 0' >{tireInfoData.TireSerialNumberInfo.Tire.TireType.name}</UI.P>
                    </UI.Div>
                  </Col>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >รุ่น</UI.P>
                      <UI.P margin='0 8px 16px 0' >{tireInfoData.TireSerialNumberInfo.inventoryOption.variantName}</UI.P>
                    </UI.Div>
                  </Col>
                </UI.Div>
                {/* <UI.Div display='flex' flexDirection='row'>

            </UI.Div> */}
              </UI.Div>
            }
          </UI.Div>
        </Col>
      )
    case 14:
      if (initialData[data.id]) {
        return (
          <Col span={data.span} offset={data.offset}>
            <UI.Div display='flex' flexDirection='row'>
              <Col span={6} >
                <UI.Div display='flex' flexDirection='column'>
                  <UI.P margin='0 8px 16px 0' >วันที่จ่าย</UI.P>
                  <UI.P margin='0 8px 16px 0' >{moment(initialData[data.id]).format('DD/MM/YYYY')}</UI.P>
                </UI.Div>
              </Col>
            </UI.Div>
          </Col>
        )
      }
      return null
    case 15:
      if (initialData[data.id]) {
        return (
          <Col span={data.span} offset={data.offset}>
            <UI.Div display='flex' flexDirection='row'>
              <Col span={6} >
                <UI.Div display='flex' flexDirection='column'>
                  <UI.P margin='0 8px 16px 0' >ยอดเงิน</UI.P>
                  <UI.P margin='0 8px 16px 0' >{initialData[data.id]} บาท</UI.P>
                </UI.Div>
              </Col>
            </UI.Div>
          </Col>
        )
      }
      return null
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, mutationVariables, setMutationVariables,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} onChangeHandler={onChangeHandler} mutationVariables={mutationVariables} setMutationVariables={setMutationVariables} />
    case detailMode.EDIT:
      return <EditMode data={data} initialData={initialData} onChangeHandler={onChangeHandler} mutationVariables={mutationVariables} setMutationVariables={setMutationVariables} />
    case detailMode.VIEW:
      return <EditMode data={data} disabled={true} initialData={initialData} onChangeHandler={onChangeHandler} mutationVariables={mutationVariables} />
    default:
      return <p>no mode</p>
  }
}
